import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsCaveat } from 'components/common/ns-caveat/NsCaveat';
import { useNavigation } from 'hooks/useNavigation';
import { PAYMENT_NAMES, PAYMENT_METHODS } from 'config/app-config';

export const testId = 'prepayInfoTestId';

export const PrepayInfo = () => {
  const { eventTypes, next } = useNavigation();

  const handleGoNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <>
      <NsPanel testId={testId}>
        <NsBackCta />
        <NsForm onSubmit={handleGoNext}>
          <NsTitle
            title={
              <>
                We can only offer you {PAYMENT_NAMES[PAYMENT_METHODS.PREPAY]}{' '}
                for your energy`
              </>
            }
          />
          <p>
            We noticed that the address provided has a{' '}
            {PAYMENT_NAMES[PAYMENT_METHODS.PREPAY]} meter. You&apos;ll have to
            top up your key or card in a Post Office or Payzone to use energy.
          </p>
          <p>
            If you&apos;d like to change to Direct Debit, we may be able to help
            once we&apos;re supplying your home.
          </p>
          <NsPrimaryCta>Continue</NsPrimaryCta>
        </NsForm>
      </NsPanel>
      <NsCaveat heading="Additional information" />
    </>
  );
};

export default PrepayInfo;
